import { openModal } from 'redux/modules/common-modal/actions';

const showErrorModalNumberOfGiftVouchers = () =>
  openModal({
    id: 'checkout-gift-voucher-limit',
    severity: 'info',
    messageText: ['Sorry, you can have a maximum of 10 gift vouchers on this order.'],
    titleText: 'Gift voucher limit reached',
    webview: {
      id: 'checkout-error-gift-voucher-limit',
    },
  });

export default showErrorModalNumberOfGiftVouchers;
